import { useState, useEffect } from 'react';

/**
 * Returns true when the page is visible, false when hidden.
 * Uses the Page Visibility API (visibilitychange event).
 */
export function usePageVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(!document.hidden);

  useEffect(() => {
    const handler = () => setIsVisible(!document.hidden);
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);

  return isVisible;
}
